import React, { useEffect } from "react";
import classes from "./Authorsblogs.module.css";
import photo from "../../assests/img/john-doe.webp";
import imp from "../../assests/img/react-beta.png";
import Pagination from "@mui/material/Pagination";

const Authorsblogs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div style={{ marginRight: 25, marginLeft: 25 }}>
        <div className={classes["detail-content-k"]}>
          <div className={classes["detail-content-k-container"]}>
            <img
              style={{
                background: "#E2E8F0",
                width: "150px",
                height: "150px",
                marginRight: 80,
              }}
              class="w-10 h-10 rounded-full"
              src={photo}
              alt=""
            />
            <div className={classes["detail-author"]}>
              <div className={classes["detail-author-container"]}>
                <h5 className={classes["author-name"]}>John Doe</h5>
                <div style={{ display: "flex" }}>
                  <div style={{ width: "300px", marginRight: "40px" }}>
                    <h5 className={classes["author-work"]}>Web Developer</h5>
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Qui debitis dolor molestias omnis amet! Optio labore
                      explicabo quos ullam quia?
                    </p>
                  </div>
                  <div>
                    <h5 className={classes["author-work"]}>Social Media</h5>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <svg
                        style={{ width: "20px", fill: "#5A67D8" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z" />
                      </svg>
                      <p
                        style={{
                          fontWeight: "500",
                          color: "#718096",
                          marginLeft: 10,
                        }}
                      >
                        Facebook
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: 10,
                      }}
                    >
                      <svg
                        style={{ width: "20px", fill: "#C13584" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                      </svg>
                      <p
                        style={{
                          fontWeight: "500",
                          color: "#718096",
                          marginLeft: 10,
                        }}
                      >
                        Instagram
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: 10,
                      }}
                    >
                      <svg
                        style={{ width: "20px", fill: "#0084C6" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 496 512"
                      >
                        <path d="M248,8C111.033,8,0,119.033,0,256S111.033,504,248,504,496,392.967,496,256,384.967,8,248,8ZM362.952,176.66c-3.732,39.215-19.881,134.378-28.1,178.3-3.476,18.584-10.322,24.816-16.948,25.425-14.4,1.326-25.338-9.517-39.287-18.661-21.827-14.308-34.158-23.215-55.346-37.177-24.485-16.135-8.612-25,5.342-39.5,3.652-3.793,67.107-61.51,68.335-66.746.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.608,69.142-14.845,10.194-26.894,9.934c-8.855-.191-25.888-5.006-38.551-9.123-15.531-5.048-27.875-7.717-26.8-16.291q.84-6.7,18.45-13.7,108.446-47.248,144.628-62.3c68.872-28.647,83.183-33.623,92.511-33.789,2.052-.034,6.639.474,9.61,2.885a10.452,10.452,0,0,1,3.53,6.716A43.765,43.765,0,0,1,362.952,176.66Z" />
                      </svg>
                      <p
                        style={{
                          fontWeight: "500",
                          color: "#718096",
                          marginLeft: 10,
                        }}
                      >
                        Telegram
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes["detail-box-bg"]}>
          <h2 className={classes["featured"]}>Blogs</h2>
          <div className={classes["s2-box-flex"]}>
            <div className={classes["main"]}>
              <div className={classes["main-box"]}>
                <img className={classes["main-box-img"]} src={imp} alt="" />
                <div className={classes["s2-name"]}>
                  <div className={classes["s2-name-container"]}>React</div>
                </div>
                <div className={classes["s2-content"]}>
                  <h3>How To Create a Responsive Top Navigation Menu</h3>
                  <div
                    style={{ marginTop: 27 }}
                    class="flex items-center space-x-4"
                  >
                    <img
                      style={{
                        background: "#E2E8F0",
                        width: "50px",
                        marginRight: 15,
                      }}
                      class="w-10 h-10 rounded-full"
                      src={photo}
                      alt=""
                    />
                    <div class="font-medium dark:text-white">
                      <div style={{ color: "#2d3849" }}>Jese Leos</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#2d3849",
                        }}
                      >
                        <div
                          style={{ color: "#2d3849" }}
                          class="text-sm text-gray-500 dark:text-gray-400"
                        >
                          May 26,2020
                        </div>
                        <svg
                          style={{ marginRight: 10, marginLeft: 10 }}
                          stroke="currentColor"
                          fill="#2d3849"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          class="css-uk6cul"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                        </svg>
                        2min
                      </div>
                    </div>
                  </div>
                  <div className={classes["eye-main"]}>
                    <div className={classes["eye-container"]}>
                      <svg
                        style={{ width: "20px", fill: "#718096" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                      </svg>
                      <p>1000</p>
                    </div>
                    <svg
                      style={{
                        width: "20px",
                        fill: "#718096",
                        marginLeft: "25px",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes["main"]}>
              <div className={classes["main-box"]}>
                <img className={classes["main-box-img"]} src={imp} alt="" />
                <div className={classes["s2-name"]}>
                  <div className={classes["s2-name-container"]}>React</div>
                </div>
                <div className={classes["s2-content"]}>
                  <h3>How To Create a Responsive Top Navigation Menu</h3>
                  <div
                    style={{ marginTop: 27 }}
                    class="flex items-center space-x-4"
                  >
                    <img
                      style={{
                        background: "#E2E8F0",
                        width: "50px",
                        marginRight: 15,
                      }}
                      class="w-10 h-10 rounded-full"
                      src={photo}
                      alt=""
                    />
                    <div class="font-medium dark:text-white">
                      <div style={{ color: "#2d3849" }}>Jese Leos</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#2d3849",
                        }}
                      >
                        <div
                          style={{ color: "#2d3849" }}
                          class="text-sm text-gray-500 dark:text-gray-400"
                        >
                          May 26,2020
                        </div>
                        <svg
                          style={{ marginRight: 10, marginLeft: 10 }}
                          stroke="currentColor"
                          fill="#2d3849"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          class="css-uk6cul"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                        </svg>
                        2min
                      </div>
                    </div>
                  </div>
                  <div className={classes["eye-main"]}>
                    <div className={classes["eye-container"]}>
                      <svg
                        style={{ width: "20px", fill: "#718096" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                      </svg>
                      <p>1000</p>
                    </div>
                    <svg
                      style={{
                        width: "20px",
                        fill: "#718096",
                        marginLeft: "25px",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes["main"]}>
              <div className={classes["main-box"]}>
                <img className={classes["main-box-img"]} src={imp} alt="" />
                <div className={classes["s2-name"]}>
                  <div className={classes["s2-name-container"]}>React</div>
                </div>
                <div className={classes["s2-content"]}>
                  <h3>How To Create a Responsive Top Navigation Menu</h3>
                  <div
                    style={{ marginTop: 27 }}
                    class="flex items-center space-x-4"
                  >
                    <img
                      style={{
                        background: "#E2E8F0",
                        width: "50px",
                        marginRight: 15,
                      }}
                      class="w-10 h-10 rounded-full"
                      src={photo}
                      alt=""
                    />
                    <div class="font-medium dark:text-white">
                      <div style={{ color: "#2d3849" }}>Jese Leos</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#2d3849",
                        }}
                      >
                        <div
                          style={{ color: "#2d3849" }}
                          class="text-sm text-gray-500 dark:text-gray-400"
                        >
                          May 26,2020
                        </div>
                        <svg
                          style={{ marginRight: 10, marginLeft: 10 }}
                          stroke="currentColor"
                          fill="#2d3849"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          class="css-uk6cul"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                        </svg>
                        2min
                      </div>
                    </div>
                  </div>
                  <div className={classes["eye-main"]}>
                    <div className={classes["eye-container"]}>
                      <svg
                        style={{ width: "20px", fill: "#718096" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                      </svg>
                      <p>1000</p>
                    </div>
                    <svg
                      style={{
                        width: "20px",
                        fill: "#718096",
                        marginLeft: "25px",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes["main"]}>
              <div className={classes["main-box"]}>
                <img className={classes["main-box-img"]} src={imp} alt="" />
                <div className={classes["s2-name"]}>
                  <div className={classes["s2-name-container"]}>React</div>
                </div>
                <div className={classes["s2-content"]}>
                  <h3>How To Create a Responsive Top Navigation Menu</h3>
                  <div
                    style={{ marginTop: 27 }}
                    class="flex items-center space-x-4"
                  >
                    <img
                      style={{
                        background: "#E2E8F0",
                        width: "50px",
                        marginRight: 15,
                      }}
                      class="w-10 h-10 rounded-full"
                      src={photo}
                      alt=""
                    />
                    <div class="font-medium dark:text-white">
                      <div style={{ color: "#2d3849" }}>Jese Leos</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#2d3849",
                        }}
                      >
                        <div
                          style={{ color: "#2d3849" }}
                          class="text-sm text-gray-500 dark:text-gray-400"
                        >
                          May 26,2020
                        </div>
                        <svg
                          style={{ marginRight: 10, marginLeft: 10 }}
                          stroke="currentColor"
                          fill="#2d3849"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          class="css-uk6cul"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                        </svg>
                        2min
                      </div>
                    </div>
                  </div>
                  <div className={classes["eye-main"]}>
                    <div className={classes["eye-container"]}>
                      <svg
                        style={{ width: "20px", fill: "#718096" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                      </svg>
                      <p>1000</p>
                    </div>
                    <svg
                      style={{
                        width: "20px",
                        fill: "#718096",
                        marginLeft: "25px",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes["main"]}>
              <div className={classes["main-box"]}>
                <img className={classes["main-box-img"]} src={imp} alt="" />
                <div className={classes["s2-name"]}>
                  <div className={classes["s2-name-container"]}>React</div>
                </div>
                <div className={classes["s2-content"]}>
                  <h3>How To Create a Responsive Top Navigation Menu</h3>
                  <div
                    style={{ marginTop: 27 }}
                    class="flex items-center space-x-4"
                  >
                    <img
                      style={{
                        background: "#E2E8F0",
                        width: "50px",
                        marginRight: 15,
                      }}
                      class="w-10 h-10 rounded-full"
                      src={photo}
                      alt=""
                    />
                    <div class="font-medium dark:text-white">
                      <div style={{ color: "#2d3849" }}>Jese Leos</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#2d3849",
                        }}
                      >
                        <div
                          style={{ color: "#2d3849" }}
                          class="text-sm text-gray-500 dark:text-gray-400"
                        >
                          May 26,2020
                        </div>
                        <svg
                          style={{ marginRight: 10, marginLeft: 10 }}
                          stroke="currentColor"
                          fill="#2d3849"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          class="css-uk6cul"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                        </svg>
                        2min
                      </div>
                    </div>
                  </div>
                  <div className={classes["eye-main"]}>
                    <div className={classes["eye-container"]}>
                      <svg
                        style={{ width: "20px", fill: "#718096" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                      </svg>
                      <p>1000</p>
                    </div>
                    <svg
                      style={{
                        width: "20px",
                        fill: "#718096",
                        marginLeft: "25px",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes["main"]}>
              <div className={classes["main-box"]}>
                <img className={classes["main-box-img"]} src={imp} alt="" />
                <div className={classes["s2-name"]}>
                  <div className={classes["s2-name-container"]}>React</div>
                </div>
                <div className={classes["s2-content"]}>
                  <h3>How To Create a Responsive Top Navigation Menu</h3>
                  <div
                    style={{ marginTop: 27 }}
                    class="flex items-center space-x-4"
                  >
                    <img
                      style={{
                        background: "#E2E8F0",
                        width: "50px",
                        marginRight: 15,
                      }}
                      class="w-10 h-10 rounded-full"
                      src={photo}
                      alt=""
                    />
                    <div class="font-medium dark:text-white">
                      <div style={{ color: "#2d3849" }}>Jese Leos</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#2d3849",
                        }}
                      >
                        <div
                          style={{ color: "#2d3849" }}
                          class="text-sm text-gray-500 dark:text-gray-400"
                        >
                          May 26,2020
                        </div>
                        <svg
                          style={{ marginRight: 10, marginLeft: 10 }}
                          stroke="currentColor"
                          fill="#2d3849"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          class="css-uk6cul"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                        </svg>
                        2min
                      </div>
                    </div>
                  </div>
                  <div className={classes["eye-main"]}>
                    <div className={classes["eye-container"]}>
                      <svg
                        style={{ width: "20px", fill: "#718096" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                      </svg>
                      <p>1000</p>
                    </div>
                    <svg
                      style={{
                        width: "20px",
                        fill: "#718096",
                        marginLeft: "25px",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Pagination
            sx={{ display: "flex", justifyContent: "center", marginTop: 3 }}
            count={10}
            shape="rounded"
          />
        </div>
      </div>
    </>
  );
};

export default Authorsblogs;
